import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {partition} from 'lodash';
import {z} from 'zod';

import {fetchAndDeserialize} from '../../util/api-adapter';
import {rootApiUrl} from '../api/api-const';

const reviewRepliersSchema = z.object({
    email: z.string(),
    firstName: z.string().nullable(),
    fullName: z.string().nullable(),
    lastName: z.string().nullable(),
    id: z.number(),
    isAgency: z.boolean(),
});

export type ReviewReplierType = z.infer<typeof reviewRepliersSchema>;

type ReviewReplierArrayType = {
    results: Array<ReviewReplierType>;
};

type TransformedReplierType = {
    internalAgencyRepliers: Array<ReviewReplierType>;
    repliers: Array<ReviewReplierType>;
};

const reviewsReviewsReplierListUrl = `${rootApiUrl}/v4/reviews/repliers/`;

function fetchReviewsReplierList(): Promise<ReviewReplierArrayType> {
    return fetchAndDeserialize('/v4/reviews/repliers/', z.array(reviewRepliersSchema));
}

export function useReviewsReplierList(): UseQueryResult<TransformedReplierType> {
    return useQuery([reviewsReviewsReplierListUrl], fetchReviewsReplierList, {
        refetchOnWindowFocus: false,
        select: (data) => {
            const [internalAgencyRepliers, repliers] = partition(data.results, (replier) => replier.isAgency);

            return {internalAgencyRepliers, repliers};
        },
    });
}
